import React from 'react';
import classNames from 'classnames';
import './WeekdayNames.less';

function WeekdayNames({dayNames, shortDayNames, longDayNames, simple, startOfWeek = 0, showGridlines}) {
    const weekDayNameClasses = classNames('weekday-names', {
        'weekday-names--no-gridlines': !showGridlines
    });

    return (
        <tr className={weekDayNameClasses}>
            {[0, 1, 2, 3, 4, 5, 6].map((x, i) => {
                const weekend = (startOfWeek === 0 && (i === 0 || i === 6)) || (startOfWeek === 1 && (i === 5 || i === 6));

                const weekDayClasses = classNames({
                    'weekday-title': true,
                    weekend,
                    simple
                });

                return (
                    <th scope="col" className={weekDayClasses} key={`weekday-${i}`}>
                        <span aria-hidden="true">{simple ? shortDayNames[i] : dayNames[i]}</span>
                        <span className="sr-only">{longDayNames[i]}</span>
                    </th>
                );
            })}
        </tr>
    );
}

export default WeekdayNames;
